import React, { useState, useEffect } from 'react';

import { ajaxor2, ajaxor0 } from '../../common/basic';
import getNLS from '../../common/_NLS';

import FixedDetail from '../detail/FixedDetail';

const awsURL = "https://s3.ap-northeast-2.amazonaws.com/camscon.seoul";
// https://api.camscon.kr/v1/inspiration/feed?limit=12&page=2&order=hot
export default props=>{
  const [dFixedDetail, setDFixedDetail] = useState('none');
  const [vFixedDetail, setFixedDetail] = useState(null);

  if (process.browser) setSolid("weeklyBest " + dFixedDetail);

  const [vWeeklyBest, setWeeklyBest] = useState([]);

  // 기본(.image0)은 좌우 맞춤인데, 그중에서,
  // 이미지 1:1보다 길고, 416*500 크기보다는 짧은 사진에 대해서는
  // (.m15)상하맞춤+좌우버리기
  useEffect(() => {
    $('.image0').each((i,e)=>{
      $(e).addClass('m15');
    });
    return () => null;
  });


  
  useEffect(() => {
    ajaxor2({
      // url: "/inspiration/best",
      url: "/communityR4",
      callback: setWeeklyBest,
    });

    return () => { };
  }, []);


  function goPopup(cid){
    ajaxor0({
      url: "/inspiration/single/"+cid,
      callback:callback,
    });
    function callback(r){
      // setFixedDetail(vWeeklyBest[1]);
      setFixedDetail(r.data);
      setDFixedDetail('block');
    }
  }
  const jsx = (<div className="pan5">
    <style jsx>{`

.display-inline{
  display: inline;
  margin: 0 2.5%;
  vertical-align: middle;
  
}

.MOST-POPULAR {
  font-size: 18px;
font-weight: bold;
  color: #343a40;
}

.fourinone{
  width:1290px;
}

.fourinone td{
  width:25%;
  min-width: 29px;
  padding: 0;
  overflow: scroll;
}

.item {
  width: 300px;
  height: 400px;
  padding: 0;
  margin-right: 29px;
  border: 0;

  position: relative;
  background-color: black;
  overflow: hidden;
}


.image0 {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}

.m15.image0 {
  height: 100%;
  width: auto;
}


.item .best4{
  position: absolute;
  left: 15px;
  bottom: 35px;

  font-size: 13px;
  font-weight: 500;
  line-height: 1.38;
  letter-spacing: -0.25px;
  color: #ffd43b;
}


.item .Inspired-by-Camscon{
  position: absolute;
  left: 15px;
  bottom: 16px;

  font-size: 13px;
  line-height: 1.38;
  letter-spacing: -0.25px;
  color: #ffffff;

}

.fourinone img {
  width: 100%;
  height: auto;
}

.frame{
  width: 100%;
  overflow-y: hidden;
}

.frame::-webkit-scrollbar { 
    display: none; 
}


@media all and (max-width:606px) {
  .fourinone{
    width: 100%;
  }

  .sss{display: none;}

  .MOST-POPULAR a{
    float: right;
  }

  .MOST-POPULAR a img{
    /* width: 111px; */
  }
}


`}</style>

    <div className="MOST-POPULAR">
      {getNLS("인기 포스팅")}
      {props.lookaround ?
        <a className="dibom" href="/lookaround">
          <img className="see" src="/assets/images/group-5.svg" />
        </a>
      : null}
    </div>
    <div className="dnom">&nbsp;</div>
    <div className="frame" >
      <FixedDetail display={dFixedDetail} hide={() => setDFixedDetail('none')} me={vFixedDetail}/>

      <table className="fourinone"><tbody>
        <tr className="aline">

          {vWeeklyBest && vWeeklyBest.map((v,i)=><>
            <td className="">
              <div className="item base leftside mouse-aa" onClick={() => goPopup(v.id)}>
                {/* <a><img className="" src="/assets/images/crop/wb8.png" /></a> */}
                {/* <a><img className="image0" src={v && v.images ? v.images[0].optimized_url :''} /></a> */}
                <a><img className="image0" src={(v ? awsURL + v.storage_path + "/" + v.optimized : '')} /></a>

                <div className="best4">BEST {i+1}</div>
                <div className="Inspired-by-Camscon"
                  onClick={e=>{
                    e.preventDefault();
                    e.stopPropagation();
                    location.href = "/person/Blog?userid=" +v.user_id;

                  }}
                >{v && v.username}</div>
              </div>
            </td>
          </>)}
          <td className="dnom" style={{ width: "" + (4 - vWeeklyBest.length) * 25 + "%" }}></td>
          

        </tr>
      </tbody></table>

    </div>
  </div>);

  if(vWeeklyBest.length >= 1) return (jsx);
  else return <></>;
};